<template>
  <div>
    <template v-if="mode === INLINE_FORM_MODE.VIEW">
      <div
        class="category-item view"
        :class="{active: isActive}"
        @click="handleClickItem"
      >
        <img
          class="folder-icon"
          src="/image/folder/normal.png"
        >
        <span>{{ form.name }}</span>
        <div
          v-if="isActive"
          class="category-item-control"
        >
          <button
            class="cancel"
            @click.stop="handleClickEdit"
          >
            수정
          </button>
          <button
            class="confirm"
            @click="handleClickDelete"
          >
            삭제
          </button>
        </div>
      </div>
    </template>
    <template v-if="mode === INLINE_FORM_MODE.FORM">
      <div class="category-item form">
        <img
          class="folder-icon"
          src="/image/folder/ing.png"
        >
        <input
          ref="inputCategoryName"
          v-model="form.name"
          type="text"
          placeholder="카테고리명 입력"
        >
        <div class="category-item-control">
          <button
            class="cancel"
            style="margin-left: 0;"
            @click="handleClickCancelForm"
          >
            취소
          </button>
          <button
            class="confirm"
            @click="handleClickSaveForm"
          >
            확인
          </button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { INLINE_FORM_MODE } from '../../../constants';

export default {
  name: 'CategoryItem',
  props: [
    'mode', 'data', 'isActive',
  ],
  data() {
    return {
      INLINE_FORM_MODE,
      form: {
        id: null,
        name: '',
        courses: [],
      },
      beforeForm: {
        id: null,
        name: '',
        courses: [],
      },
    };
  },
  watch: {
    mode(value) {
      this.$nextTick(() => {
        if (value === INLINE_FORM_MODE.FORM) {
          this.$refs['inputCategoryName'].focus();
        }
      });
    },
  },
  created() {
    if (this.data) {
      this.form = this.data;
    }

    this.$nextTick(() => {
      if (this.$refs['inputCategoryName']) this.$refs['inputCategoryName'].focus();
    });
  },
  methods: {
    handleClickSaveForm() {
      if (this.form.id) {
        return this.$emit('update', this.form);
      }

      this.$emit('create', this.form);
    },
    handleClickEdit() {
      this.beforeForm = JSON.parse(JSON.stringify(this.form));

      this.$emit('changeMode', {
        id: this.form.id,
        mode: INLINE_FORM_MODE.FORM,
      });
    },
    handleClickDelete() {
      this.$emit('delete', this.form);
    },
    handleClickCancelForm() {
      this.form = this.beforeForm;

      this.$emit('changeMode', {
        id: this.form.id,
        mode: INLINE_FORM_MODE.VIEW,
      });
    },
    handleClickItem() {
      this.$emit('select', {
        id: this.form.id,
      });
    },
  },
};
</script>

<style lang="scss">
.category-item-control {
	flex: initial;

	button {
		background-color: transparent;
		font-size: 11px;
		padding: 0 1px;
		line-height: 20px;
		letter-spacing: -0.6px;
		color: #ffffff;
		border: 0;
		margin-left: 10px;

		&.edit {
			color: white;
		}

		&.delete {
			color: #4a4a4a;
		}

		&.cancel {
			color: #d3d3d3;
		}

		&.confirm {
			color: #4a4a4a;
		}

		&:hover {
			cursor: pointer;
			text-decoration: underline;
		}

		&:focus {
			outline: none;
		}
	}
}
</style>
